import React from "react";
import "./About_Info.css";
import parse from "html-react-parser";
function About_Info({ about_us }) {
  return (
    <>
      <section className="About_Info fadeInLeft">
        <div className="container-fluid">
          <div className="text_holder">
            <p>
              {typeof about_us?.content === "string" ? (
                parse(about_us.content)
              ) : (
                <p>No content available.</p>
              )}
            </p>
          </div>
        </div>
      </section>
    </>
  );
}

export default About_Info;
